import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import { launchColors } from '../launchTheme';
import { assetThumbnailUrl, openAssetInAthena } from './AssetHoverLink';

const frameSx = {
  width: { xs: 56, sm: 80 },
  height: { xs: 56, sm: 80 },
  flexShrink: 0,
  borderRadius: '10px',
  border: `1px solid ${launchColors.divider}`,
  bgcolor: launchColors.card,
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const Placeholder: React.FC<{ text: string }> = ({ text }) => (
  <Box title={text} sx={[frameSx, { bgcolor: launchColors.neutralBg, flexDirection: 'column', gap: 0.25 }]}>
    <ImageOutlinedIcon sx={{ fontSize: 22, color: launchColors.textMuted }} />
    <Typography sx={{ fontSize: 10, lineHeight: 1.2, color: launchColors.textMuted, textAlign: 'center', px: 0.5, display: { xs: 'none', sm: 'block' } }}>{text}</Typography>
  </Box>
);

const ProductImage: React.FC<{ assetId?: string; title: string }> = ({ assetId, title }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => { setFailed(false); }, [assetId]);
  if (!assetId) return <Placeholder text="Ingen bild i Athena" />;
  if (failed) return <Placeholder text="Ingen bild" />;
  return (
    <ButtonBase
      aria-label={`Visa bilden för ${title} i Athena`}
      title="Öppna i Athena"
      onClick={() => openAssetInAthena(assetId)}
      sx={[frameSx, { '&:hover': { borderColor: launchColors.navy }, '&.Mui-focusVisible': { outline: `2px solid ${launchColors.navy}`, outlineOffset: 2 } }]}
    >
      <Box component="img" src={assetThumbnailUrl(assetId)} alt={title} onError={() => setFailed(true)} sx={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
    </ButtonBase>
  );
};

export default ProductImage;
